import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Faq from './pages/Faq';
import './App.css';
import Header from './components/Header';
import Transparencia from './pages/Transparencia';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Header/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/transparencia" element={<Transparencia />} />
        {/* Adicione outras rotas aqui futuramente */}
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
